import { $t } from 'packages/locale'
import { ModalRouteNode, RouteConfig } from 'packages/route'
import { lazy } from 'react'

/**
 * 路由注册
 *
 * @returns 注册信息
 */
export const getRoutes: () => RouteConfig[] = () => [
  {
    path: 'user/gateway',
    name: 'UserGateway',
    getTitle: () => '首页',
    component: lazy(() =>
      import('./pages/index').then((m) => ({
        default: m.Gateway,
      }))
    ),
  },
]

export const modalRoutes: ModalRouteNode[] = [
  {
    getTitle: () => $t('数据看板'),
    name: 'GatewayStatsDetails',
    component: lazy(() =>
      import('./pages/DataBoard/StatsDetails').then((m) => ({
        default: m.StatsDetails,
      }))
    ),
  },
  {
    getTitle: () => $t('绩点详情'),
    name: 'GatewayGpaDetails',
    component: lazy(() =>
      import('./pages/DataBoard/GpaDetails').then((m) => ({
        default: m.GpaDetails,
      }))
    ),
  },
  {
    getTitle: () => $t('绩点详情'),
    name: 'GatewayNineGpaDetails',
    component: lazy(() =>
      import('./pages/DataBoard/NineGpaDetails').then((m) => ({
        default: m.NineGpaDetails,
      }))
    ),
  },
  {
    getTitle: () => $t('学分详情'),
    name: 'GatewayZeroCreditDetails',
    component: lazy(() =>
      import('./pages/DataBoard/GatewayZeroCreditDetails').then((m) => ({
        default: m.GatewayZeroCreditDetails,
      }))
    ),
  },
]
